import React, { createContext, PropsWithChildren } from 'react';

import { CollectionProgressItem, DetailedProject, Reservation } from '../../../../api-client';

export type DetailedProjectContextType = {
  project: DetailedProject;
  reservation?: Reservation | null;
  reservationLoading?: boolean;
  setReservation?: (reservation: Reservation | null) => void;
  /**
   * Ход взыскания по проекту.
   *
   * Грузится в DetailedProject, а не в самой вкладке: навигации надо знать, показывать ли
   * вкладку "Ход взыскания", ещё до того, как её откроют, — данные по взысканию есть лишь
   * у части проектов.
   *
   * Пустой массив — данных нет (это норма), null — ещё не загружено.
   */
  collection?: ReadonlyArray<CollectionProgressItem> | null;
  collectionLoading?: boolean;
};

type Props = {
  props: DetailedProjectContextType;
};

// @ts-ignore
export const DetailedProjectContext = createContext<DetailedProjectContextType>();

function DetailedProjectContextProvider(props: PropsWithChildren<Props>) {
  const { children, ...value } = props;
  return (
    <DetailedProjectContext.Provider value={value.props}>
      {children}
    </DetailedProjectContext.Provider>
  );
}

export default DetailedProjectContextProvider;
